export default (initialCount) => ({
  count: initialCount,

  update(event) {
    this.count = event.target.value.length;
  },
});
